import NavBar from "./Header/NavBar";
import Settings from "./Header/Settings";
import SiteLogo from "./Header/SiteLogo";

const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full h-[80px] bg-white px-[10px] border-b-[8px] border-first_color  shadow-[0px_5px_15px_-1px_#b07f4a]">
      <div className="mainContainer w-full h-full flex items-center justify-between gap-3 lg:gap-9 ">
        {/* logo */}
        <div className="lg:w-[20%] flex items-center ">
          <SiteLogo />
        </div>

        {/* NavBar  */}
        <NavBar />

        {/* login and language section  */}
        <Settings />
      </div>
    </header>
  );
};

export default Header;
